import escapeHtml from 'src/escapeHtml'

// 🔑 **The modal close button, built once — `TODO.md` U-95.**
//
// `shared/_modal_shell.html.erb` fixed eleven of fifteen hard-coded English `aria-label="Close"` strings
// and its comment says *"a partial cannot reach"* the other four, which is true and does not mean nothing
// can: those four are assembled in JavaScript. Three build a `.btn-close`, and the 2026-10-30 round
// inserted `I18n.t("buttons.close")` into each of them **individually** — the fifteen-places problem
// recurring at a smaller scale.
//
// 📌 **Deliberately NOT the full `modalShell({ … })` builder U-95 proposed, and the reason is the one this
// branch has already applied to U-95's own `refuses_deletion` macro.** The five JS-assembled shells differ
// in dialog class, whether the header has a close button, body class, and a footer of zero, one, two or
// three buttons — a builder covering them needs six or seven options, which is more configuration than the
// five literals it would replace, and each call would still be unreadable. What is actually duplicated,
// and what actually went wrong, is this button.
//
// ⚠️ `escapeHtml` on the label: it lands in an ATTRIBUTE, and a translation is not attacker-controlled but
// the escape costs nothing and `spec/config/html_concatenation_escaping_spec.rb` wants interpolations into
// markup to be calls, not bare values.
// 🚨 **`dismiss` takes a STRING as well as a boolean, and `className` exists, because the TOAST's close
// button was a FOURTH JS-assembled `.btn-close` still carrying `aria-label='Close'`** — the only such
// literal left in `app/javascript` when `/simplify` measured it, 2026-11-03. It needed
// `data-bs-dismiss="toast"` and a colour class, which is two options rather than the six or seven a full
// shell builder would have taken — so the 📌 above still stands and this is the same button, not a
// builder.
// ⚠️ `dismiss: true` keeps meaning `"modal"`, so the three existing call sites are unchanged.
export function closeButton({ id = null, dismiss = true, className = null } = {}) {
  const target = dismiss === true ? 'modal' : dismiss

  return '<button type="button"' +
    (id ? ' id="' + escapeHtml(id) + '"' : '') +
    ' class="btn-close' + (className ? ' ' + escapeHtml(className) : '') + '"' +
    (target ? ' data-bs-dismiss="' + escapeHtml(target) + '"' : '') +
    ' aria-label="' + escapeHtml(I18n.t('buttons.close')) + '"></button>'
}

export default closeButton
